// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { PartnerState } from "@/types/partner";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Partner } from "@/models/partner";

const state: PartnerState = {
  single: new Partner(),
  pagination: new Pagination(),
};

export const partner: Module<PartnerState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
